import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import Button from "../../../../../components/Common/Button/Button";
import Input from "../../../../../components/Common/Input/Input";
import classes from "./CreateForumThread.module.scss";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux/es/exports";
import { createForumThreadActionHandler } from "../../../../../store/actions/actionHandlers/socialActionHandler";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const threadSchema = yup.object().shape({
  threadDescription: yup.string().trim().required("Description is required"),
});

const CreateForumThread = ({ topicsId, setCreateForumThreadModal }) => {
  const dispatch = useDispatch();
  const methods = useForm({
    resolver: yupResolver(threadSchema),
  });
  const {
    handleSubmit,
    formState: { errors },
  } = methods;
  const socialState = useSelector((state) => state.socialReducer);
  const { createForumThreadLoader } = socialState;

  const onSubmit = (data) => {
    const obj = {
      ThreadName: data.threadDescription,
      TopicsId: topicsId,
    };
    dispatch(createForumThreadActionHandler(obj, setCreateForumThreadModal));
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.createForumThread}
      >
        <Input
          label={<FormattedMessage id="FORUM_DESCRIPTION" />}
          name="threadDescription"
          placeholder="Enter Thread Details"
          labelColor="light"
          width="40"
          type="textarea"
          rows={3}
          error={errors?.threadDescription?.message}
          required
          maxLength="300"
        />
        <Button
          type="submit"
          label={<FormattedMessage id="SAVE_TXT" />}
          small
          dark
          backgroundColor={createForumThreadLoader ? undefined : "#D31B61"}
          loading={createForumThreadLoader}
        />
      </form>
    </FormProvider>
  );
};

export default CreateForumThread;
